import React from 'react';

import ListItem from '../../list-items/ListItem';
import './QueryList.css';

const InputText = React.memo(props=>{
  return(
    <input
      name={props.name}
      type={props.type}
      className={props.className}
      id={props.id}
      size={props.size}
      onChange={props.onChange}
      value={props.value}
    />
  )
})

const QueryList = (props) => {
  return (
    <>
      <div className="createGroupBtn"><a className="button grayLine" onClick={()=>props.handleAllSelectBtn()}>전체선택</a> <a className="button grayLine" onClick={()=>props.handleAllDeselectBtn()}>전체해제</a> <a className="button grayLine" onClick={()=>props.handleExportBtn()}>내보내기</a></div>
      <div className="groupSearch">
        {/* <InputText onChange={props.handleSearchInput} value={props.queryFilter} name="textfield" type="text" className="box" id="textfield" size="25" /><a onClick={()=>props.handleSearchBtn(JSON.stringify(props.queryLabelData))} className="button purple_line" style={{padding: "5px 15px", marginLeft: "4px"}}>검색</a> */}
        <InputText onChange={props.handleSearchInput} value={props.queryFilter} name="textfield" type="text" className="box" id="textfield" size="25" /><a onClick={()=>props.handleSearchBtn(JSON.stringify(props.queryLabelData))} className="button purple_line" style={{marginLeft: "4px"}}>검색</a>
      </div>
      <div className="createGroup">
        <div className="overflow-component">
          {props.filteredArray.info && props.filteredArray.info.map( (item, index) => 
            <div className="queryGroup">
              <ListItem handleCheckBox={props.handleCheckBox} type={props.filteredArray.type} key={item.name+index} item={item} index={index} handleClick={props.handleClick} />
            </div>
          )}
          {props.filteredArray.nullLabelItem && props.filteredArray.nullLabelItem.map( (item, index)=> 
            <ListItem handleCheckBox={props.handleCheckBox} handleClick={props.handleClick} type={props.filteredArray.nullLabelItemType} key={item.name+index} item={item} index={index} />
          )}
        </div>
      </div>
    </>
  )
}

export default QueryList;
